// import { loadLocaleMessages, setI18nLanguage } from "@/i18n";

// import { useUserStore } from "@/stores/user";
// import { useAppStore } from "@/stores/app";
import { NavigationGuardWithThis } from "vue-router";

export const beforeEachGuard: NavigationGuardWithThis<undefined> = async (to, from, next) => {
  // NOTE: If switching languages

  // const userStore = useUserStore();
  // const savedLocale = userStore.locale;

  // const { toLocale = savedLocale } = to.params;

  // let paramsLocale = Array.isArray(toLocale) ? toLocale[0] : toLocale;

  // const localeExists = AVAILABLE_LOCALES.includes(paramsLocale);

  // if (localeExists) {
  //   await loadLocaleMessages(i18n, paramsLocale);
  // } else {
  //   return next(`/${defaultLocale}`);
  // }

  // setI18nLanguage(i18n, paramsLocale)

  return next();
};